import IncidentSection4 from './IncidentSection4';

export default IncidentSection4;
